require('./accountDebitsEditErrorStep.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const WizardError = require('components/commons/wizardError/wizardError')

const AccountDebitsEditErrorStep = props => {
    const { accountId } = props
    const linkLabel = formatText('accountDebitsEditError-linkText').toUpperCase();
    const link = `/myprofile/accounts/${accountId}/debits`;
    const goBackButton = {
        label: linkLabel,
        url: link
    }
    return (
        <WizardError
            errorMessage={formatText('accountDebitsEditError-title')}
            mainButton={goBackButton}
        >
            <FormattedText className="account-debits-edit-error-step__sub-message" value="accountDebitsEditError-subMessage"/>
        </WizardError>
    );
};

AccountDebitsEditErrorStep.propTypes = {
    accountId: PropTypes.string
}

module.exports = AccountDebitsEditErrorStep;
